[
   {
      "display": "true",
      "ui_columnname": "Action",
      "db_columnname": "Action",
      "datatype": "String",
      "mappingkey": "Action",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "",
      "dropdownvalue": ""
  }, 
   {
       "display":"true",
       "ui_columnname":"User ID",
       "db_columnname":"userId",
       "datatype":"String",
       "mappingkey":"userId",
       "dropdown":"NO",
       "disabled":"true",
       "value":"",
       "dropdownvalue":""
    },
    {
        "display":"true",
        "ui_columnname":"User Name",
        "db_columnname":"userName",
        "datatype":"String",
        "mappingkey":"userName",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Client ID",
        "db_columnname":"clientName",
        "datatype":"String",
        "mappingkey":"clientName",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Role",
        "db_columnname":"roleName",
        "datatype":"String",
        "mappingkey":"roleName",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"First Name",
        "db_columnname":"first_name",
        "datatype":"String",
        "mappingkey":"firstName",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Last Name",
        "db_columnname":"last_name",
        "datatype":"String",
        "mappingkey":"lastName",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Email ID",
        "db_columnname":"userName",
        "datatype":"String",
        "mappingkey":"userName",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Active",
        "db_columnname":"active",
        "datatype":"String",
        "mappingkey":"active",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
      {
        "display":"true",
        "ui_columnname":"MFA Enabled",
        "db_columnname":"mfaEnabled",
        "datatype":"Boolean",
        "mappingkey":"mfaEnabled",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Set Password",
        "db_columnname":"permanentPasswordEnabled",
        "datatype":"Boolean",
        "mappingkey":"permanentPasswordEnabled",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Mpids",
        "db_columnname":"mpids",
        "datatype":"String",
        "mappingkey":"mpids",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
      "display":"true",
      "ui_columnname":"Created Date",
      "db_columnname":"createdDate",
      "datatype":"String",
      "mappingkey":"createdDate",
      "dropdown":"NO",
      "disabled":"true",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Created By",
      "db_columnname":"createdBy",
      "datatype":"String",
      "mappingkey":"createdBy",
      "dropdown":"NO",
      "disabled":"true",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Updated",
      "db_columnname":"updatedDate",
      "datatype":"String",
      "mappingkey":"updatedDate",
      "dropdown":"NO",
      "disabled":"true",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Updated By",
      "db_columnname":"updatedBy",
      "datatype":"String",
      "mappingkey":"updatedBy",
      "dropdown":"NO",
      "disabled":"true",
      "value":"",
      "dropdownvalue":""
   }
]